<app-gen-header
    [streamName]="userStream?.name || 'Your new Idea'"
    [streamType]="streamData?.name || ''"
></app-gen-header>
@if (streamData?.steps) {
    <div class="row wrapper">
        <div class="content">
            <div class="label-uppercase">
                STEP {{ currentStep + 1 }}/{{
                    streamData!.steps!.length || "1"
                }}
            </div>
            <div class="col gap-8">
                <h1>{{ streamData!.steps![currentStep].name }}</h1>
                <div
                    class="introductions row gap-4 align-center link"
                    (click)="openStepPreview(true)"
                >
                    <rr-icon name="info" class="w20" tone="brand"></rr-icon>
                    <span>Instructions</span>
                </div>
            </div>
            <!-- ===== CHAT AREA -->
            <div class="chatarea gap-24 col w100" #chatarea>
                <div
                    class="chtentry w100"
                    *ngFor="let c of chat; let chatIndex = index"
                >
                    <!-- Normal Text Part -->
                    <div
                        class="col gap-4 w100 padding-left-4"
                        *ngIf="c.hidden === false"
                    >
                        <div
                            class="row w100 gap-8 align-center justify-end"
                            *ngIf="c.textType === 'USER'"
                        >
                            <span class="tiny">ME</span>
                            <rr-user-avatar class="w24"></rr-user-avatar>
                        </div>

                        <div
                            class="row w100 gap-8 align-center justify-start"
                            *ngIf="c.textType === 'AI'"
                        >
                            <img
                                src="images/default-agent.png"
                                class="w24"
                                alt=""
                            />
                            <span class="tiny">JOHNNY</span>
                            @if (c.aiRunning === true) {
                                <div class="johnnyloading"></div>
                                <!-- <div class="johnnyloadingdots">
                            <div class="dots"></div>
                        </div> -->
                            }
                        </div>

                        <div
                            *ngIf="c.responseType === 'TEXT'"
                            [ngClass]="{
                                'user-message': c.textType === 'USER',
                                'bot-message': c.textType === 'AI',
                            }"
                            [innerHTML]="c.text! | markdown | async"
                        ></div>
                        <!-- Show proceed button if chatIndex is multiple of 3  -->
                        <!-- <div *ngIf="c.skipToNextQuestionBtn === true" class="row">
                        <rr-btn
                            size="Small"
                            type="Link"
                            (click)="proceedWithNextKeyQuestion()"
                            >Proceed to the next key question.</rr-btn
                        >
                    </div> -->
                        @if (c.uploadBtn === true) {
                            <div class="row gap-8 w100 uploadandgobtns">
                                <rr-btn
                                    size="Small"
                                    type="Primary"
                                    (click)="uploadDocs()"
                                    >Upload documents</rr-btn
                                >
                                <rr-btn
                                    size="Small"
                                    type="Secondary"
                                    (click)="goahead()"
                                    >Go ahead</rr-btn
                                >
                            </div>
                        }
                    </div>
                    <!-- END Normal Text Part -->

                    <!-- Suggestion -->
                    <div
                        class="col gap-8 suggestionwrapper"
                        *ngIf="
                            c.responseType === 'SUGGESTION' &&
                            c.finished === false
                        "
                    >
                        <div class="suggestion waiting">
                            <img src="/images/loading.gif" alt="" />
                        </div>
                        <div class="suggestion waiting">
                            <img src="/images/loading.gif" alt="" />
                        </div>
                        <div class="suggestion waiting">
                            <img src="/images/loading.gif" alt="" />
                        </div>
                    </div>
                    <div
                        class="col gap-8 suggestionwrapper"
                        *ngIf="
                            c.responseType === 'SUGGESTION' &&
                            c.finished === true
                        "
                    >
                        <div class="suggestions col gap-8 w100">
                            @for (
                                sug of c.suggestion;
                                track sug.id;
                                let i = $index
                            ) {
                                <div
                                    class="suggestion row gap-16 align-center pointer"
                                    (click)="clickSuggestion(sug.text, sug)"
                                >
                                    <div class="roundicon">
                                        {{ letters[i] }}
                                    </div>
                                    <div
                                        class="suggestion_content"
                                        markdown
                                        ngPreserveWhitespaces
                                    >
                                        {{ sug.text || sug }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <!-- END Suggestion Part -->
                </div>
            </div>
            @if (error) {
                <div class="w100 row gap-8 justify-start">
                    <rr-icon name="error" color="error"></rr-icon>
                    <div class="color-error">{{ error }}</div>
                </div>
            }
            <div
                class="col gap-8 messagebox"
                [ngClass]="{ disabled: disableInput }"
            >
                <textarea
                    type="text"
                    class="w100"
                    rows="1"
                    i18n
                    #textarea
                    placeholder="Your message..."
                    [formControl]="chatInput"
                    (keyup.enter)="chatEvent($event)"
                ></textarea>

                <div class="row space-between w100 align-center">
                    <div class="row.gap-8">
                        <div class="col">
                            @if (
                                streamData!.steps[currentStep]
                                    .websearchStatus === true ||
                                streamData!.steps[currentStep].uploadStatus ===
                                    true
                            ) {
                                <rr-icon
                                    name="more-vertical"
                                    class="pointer"
                                    (click)="showSubmenue = !showSubmenue"
                                >
                                </rr-icon>
                            }
                            @if (showSubmenue === true) {
                                <div
                                    class="menue-bg"
                                    (click)="showSubmenue = false"
                                ></div>
                                <div class="submenue col gap-4">
                                    @if (
                                        streamData!.steps[currentStep]
                                            .websearchStatus === true
                                    ) {
                                        <span
                                            class="item"
                                            (click)="doWebSearch()"
                                            >Run Web Search</span
                                        >
                                    }
                                    @if (
                                        streamData!.steps[currentStep]
                                            .uploadStatus === true
                                    ) {
                                        <span
                                            class="item"
                                            (click)="uploadDocs()"
                                            >Upload Document</span
                                        >
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row gap-8">
                        <!-- <rr-btn
                        type="Secondary"
                        size="Small"
                        iconStart="ai"
                        (click)="standaloneChat('GEN_Discussion')"
                        >Discussion</rr-btn
                    > -->
                        <rr-btn
                            type="Secondary"
                            size="Small"
                            iconStart="ai"
                            [disabled]="!canUseCoachMe()"
                            (click)="
                                canUseCoachMe()
                                    ? standaloneChat('GEN_Suggestions')
                                    : null
                            "
                            >Coach me</rr-btn
                        >
                        <rr-btn
                            type="Primary"
                            size="Small"
                            iconStart="send"
                            [disabled]="
                                disableInput || chatInput.value.trim() === ''
                            "
                            (click)="chatEvent($event)"
                            >Send</rr-btn
                        >
                    </div>
                </div>
            </div>
            <!-- ===== END CHAT AREA -->
        </div>
        <div class="subcontent">
            <div class="jhonny row align-center gap-8">
                <img src="images/default-agent.png" class="aiagent" alt="" />
                <div class="col">
                    <div class="jhonnyname">JOHNNY</div>
                    <div
                        class="link"
                        (click)="
                            disableInput === true ? null : resetStepResult()
                        "
                    >
                        Reset step result
                    </div>
                </div>
            </div>
            <div class="col gap-4 steparea" #keyQuestionsScrollContainer>
                @for (
                    question of currentKeyQuestions;
                    track question.question;
                    let i = $index
                ) {
                    <div
                        class="col gap-4 keyquestion {{
                            question.active === true ? 'active' : ''
                        }} {{ question.resolved === true ? 'resolved' : '' }}"
                        (click)="
                            disableInput === true
                                ? null
                                : setKeyQuestionActive(i)
                        "
                        #targetKeyQuestion
                    >
                        <div class="row gap-8 align-center pointer">
                            <div class="dot"></div>
                            <div class="col w100">
                                <h4 class="step-name">
                                    {{ question.title || question.question }}
                                </h4>
                            </div>
                        </div>
                        <div class="row gap-8 align-stretch">
                            <div class="wrapperline">
                                @if (
                                    i !==
                                    streamData!.steps![currentStep]!
                                        .keyQuestions!.length -
                                        1
                                ) {
                                    <div class="line"></div>
                                }
                            </div>
                            <div class="col w100 gap-4">
                                <div class="tiny description pointer">
                                    {{ question.description }}
                                    <div class="link tiny discusslink">
                                        Discuss again
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <!--PROMOTION AREA-->
            @if (
                streamData!.promotionArea.status === true &&
                showPromotion === true
            ) {
                <div class="promotionarea w100">
                    @if (
                        streamData!.promotionArea.videos &&
                        streamData!.promotionArea.videos!.length > 0
                    ) {
                        <div class="row space-between align-center">
                            <div class="col w100">
                                @for (
                                    video of streamData!.promotionArea.videos ||
                                        [];
                                    track video.url
                                ) {
                                    <div class="video">
                                        <img
                                            class="w100"
                                            [src]="video.thumbnail"
                                            [alt]="video.title"
                                        />
                                        <div class="videoinfo col gap-8">
                                            <h3>{{ video.title }}</h3>
                                            <div class="tiny">
                                                {{ video.description }}
                                            </div>
                                            <rr-btn
                                                size="Small"
                                                type="default-white"
                                                (click)="
                                                    openPromotionVideo(video)
                                                "
                                                >Watch Video</rr-btn
                                            >
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
            <!--END PROMOTION AREA-->
        </div>
    </div>
    <div class="row space-between align-center buttonrow">
        <div class="row gap-16 align-center">
            <!-- <rr-btn
            type="Link"
            size="Medium"
            iconStart="arrow-left"
            (click)="back()"
            >Back</rr-btn
        > -->
            <rr-btn
                type="Primary"
                size="Medium"
                (click)="canGoNextStep() ? nextStep() : null"
                [disabled]="!canGoNextStep()"
                >Next Step</rr-btn
            >
        </div>
        <div class="inner align-center row">
            <div class="label-uppercase strong stepcounter">
                STEP {{ currentStep + 1 }}/{{
                    streamData!.steps!.length || "1"
                }}
            </div>
            <rr-progress
                [progress]="
                    ((currentStep + 1) * 100) / (streamData!.steps!.length || 1)
                "
            ></rr-progress>
        </div>
        <app-stream-result-list
            [streamResults]="userStream?.results || []"
            [streamId]="userStream?.id || ''"
            (streamResultEvent)="handleResultItemEvents($event)"
        ></app-stream-result-list>
    </div>
}
@if (isLoading === true) {
    <rr-spinner></rr-spinner>
}
